import styled from 'styled-components'

export const RadioLabel = styled.label`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	padding: 5px 0;
	cursor: pointer;
	&:last-child {
		border-bottom: none;
	}
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		justify-content: space-between;
	}
`
export const RadioCircle = styled.div`
	position: relative;
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	border-radius: 50%;
	border: 2px solid ${props => props.theme.colors.brand.blueOmint};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
`

export const RadioInner = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: ${props => props.theme.colors.brand.blueOmint};
	opacity: ${props => (props.checked ? 1 : 0)};
	transform: scale(${props => (props.checked ? 1 : 0)});
	transition: all 0.2s ease;
`

export const RadioButtonListContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	width: 100%;
	${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
`
